import script from "./SettingsNumberDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsNumberDialog.vue?vue&type=script&setup=true&lang=js"

import "./SettingsNumberDialog.vue?vue&type=style&index=0&id=63b6483e&lang=scss"
import "./SettingsNumberDialog.vue?vue&type=style&index=1&id=63b6483e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63b6483e"]])

export default __exports__